export default "__VITE_ASSET__a4999f56__"